import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useAemConfig } from '@as-react/common-components';
import { makeGetProductFulfillment, makeGetProductFulfillmentBySize } from '../redux/product/selectors/ProductSelector';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../constants/i18nConstants';
export const useAvailabilityDescription = (unavailableProduct) => {
    var _a;
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const { lang } = useAemConfig();
    const fulfillment = useSelector(makeGetProductFulfillment());
    const fulfillmentBySize = useSelector(makeGetProductFulfillmentBySize());
    const hdExcluded = Boolean(fulfillment === null || fulfillment === void 0 ? void 0 : fulfillment.hdExcluded);
    const ccExcluded = Boolean(fulfillment === null || fulfillment === void 0 ? void 0 : fulfillment.ccExcluded);
    const storeSourceExcluded = Boolean(fulfillmentBySize === null || fulfillmentBySize === void 0 ? void 0 : fulfillmentBySize.storeSourceExcluded);
    const fulfillmentCopyDescription = (fulfillmentBySize === null || fulfillmentBySize === void 0 ? void 0 : fulfillmentBySize.storeSourceExcluded)
        ? ((_a = fulfillmentBySize === null || fulfillmentBySize === void 0 ? void 0 : fulfillmentBySize.fulfillmentCopy) === null || _a === void 0 ? void 0 : _a[lang.toUpperCase()]) || ''
        : (fulfillment === null || fulfillment === void 0 ? void 0 : fulfillment.fulfillmentCopyDescription) || '';
    const getKeyForText = useCallback(() => {
        if (unavailableProduct) {
            return t('pdp.productAvailability.notAvailable.title');
        }
        if ((hdExcluded || storeSourceExcluded) && !ccExcluded && !!fulfillmentCopyDescription) {
            return fulfillmentCopyDescription;
        }
        return '';
    }, [ccExcluded, hdExcluded, unavailableProduct, fulfillmentCopyDescription, storeSourceExcluded]);
    return {
        getKeyForText,
    };
};
